<template>
  <span :class="`bundle bundle-${color}`">
    {{ $t(`pbx.contact-method.type.${value}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'internal': {
            return 'fresh';
          }
          case 'external': {
            return 'yellow';
          }
          case 'sip': {
            return 'green';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>

<style lang="scss" scoped>
  .bundle {
    font-size: 13px;
    line-height: 19px;
    height: 24px;
    width: 90px;
    padding: 3px;
    font-weight: bold;
  }
</style>
